import { Controller } from "stimulus"

export default class extends Controller {

  static targets = ["search_field", "filter_type", "search_value", "query_type", "humans_count", "segment", "segment_id"]

  showMessageWithTranslation(message) {
    Weglot.translate({
      'words': [{ "t": 1, "w": message }],
      'languageTo': Weglot.getCurrentLang()
    }, function(data) {
      toastr.success(data[0]);
    });
  }

  // --- State Management ---
  get params() {
    let { filters } = document.querySelector("#filter-summary").dataset;
    try {
      return JSON.parse(filters);
    } catch {
      return [];
    }
  }

  set params(filters) {
    this.updateFilterSummary(filters);
  }

  toggleLoading(bool) {
    document.body.classList.toggle("loading-page", bool)
  }

  refreshPlugins() {
    $.fn.matchHeight._update(); // TRIGGER MATCH HEIGHT FOR FOOTER POSITIONING
    feather.replace(); // UPDATE ICONS
    $('[data-toggle="tooltip"]').tooltip(); // INITIALIZE TOOLTIP
  }

  fetchData(url, data) {
    this.toggleLoading(true)
    // Fire the chart in parallel; it draws itself when its own request returns,
    // independent of the table finishing (see fetchChart).
    this.fetchChart(url, data)
    return $.ajax({
      type: "GET",
      url: url,
      data: data,
      complete: () => {
        this.refreshPlugins()
        this.handleCustomSegment(data.segment, data.id)
        this.toggleLoading(false)
      }
    })
  }

  // Derive the chart endpoint from the table endpoint so both stay in sync.
  chartUrlFrom(url) {
    return url.replace("render_guest_table", "render_guest_chart")
  }

  // Only the guest database serves a chart. The blast and interaction recipient
  // pickers mount this controller with their own render_guest_table routes, which
  // have no render_guest_chart counterpart.
  hasChartEndpoint(url) {
    return typeof url === "string" && url.includes("guests/render_guest_table")
  }

  // Kicks off the chart aggregation as its own request. The two requests share
  // no mutable state: each carries the same read-only segment/filter params and
  // writes to different places (table -> #render_block, chart -> window.visitsData
  // + #stacked-bar-chart). We clear visitsData up front so a slow table paint can
  // never redraw the previous segment's chart before the fresh data lands.
  fetchChart(url, data) {
    if (!this.hasChartEndpoint(url)) return

    window.visitsData = undefined;
    window.visitsTitle = undefined;
    $.ajax({
      type: "GET",
      url: this.chartUrlFrom(url),
      data: data
    })
  }

  handleCustomSegment(segment, segment_id) {
    if (segment === "custom") {
      this.setFilterName();
      $("#update-segment").show();
      $("#delete-segment").attr("data-segment-id", segment_id).show();
    }
  }

  connect() {
    this.updateColumnVisibility();
    if(this.params.length > 0) {
      this.updateSequence();
    }
  }

  initialize(){
    let { segmentSelected } = this.element.dataset;
    if (segmentSelected === "true") {
      this.segmentSelected();
    }
    this.toggleLoading(false);
  }

  updateSequence() {
    const drawFlowController = this.application.getControllerForElementAndIdentifier(
        document.getElementById("form-container"), "mission-control--draw-flow");

    drawFlowController?.loadFiltersToFlow(this.params);
  }

  get accountId() {
    return document.body.dataset.accountId || $("body").data("account-id")
  }

  segmentSelected(element = this.element) {
    element.classList.add('active');

    let { segment, segment_id, segmentFilters, renderUrl, cacheKey } = element.dataset;
    let stateObj = { id: segment_id };

    window.history.pushState(stateObj, segment, this.getSegmentURL(segment_id));

    this.setSegmentName();
    this.params = JSON.parse(segmentFilters.replaceAll("=>", ":"));
    $("#segment").attr("data-value", segment);
    $("#segment_id").attr("data-value", segment_id);

    this.updateSequence();

    this.fetchData(renderUrl, {
      id: segment_id,
      segment: segment,
      cache_key: cacheKey
    });
  }

  order_table(event){
    const controller = this;
    const { renderUrl } = this.element.dataset;
    const { field, direction } = event.currentTarget.dataset;
    // Sorting re-renders #render_block (which contains the chart container), so
    // refetch the chart in parallel; the window itself is unchanged, so this is a
    // cache hit on the server side.
    this.fetchChart(renderUrl, { segment: "filter", params_array: this.params });
    $.ajax({
      type: "GET",
      url: renderUrl,
      data: { segment: "filter", params_array: this.params, cache_key: new Date(), field: field, direction: direction },
      complete: function() {
        controller.refreshPlugins();
        controller.toggleLoading(false);
        $(".direction-button").removeClass("text-primary");
        $(`.direction-button[data-field="${field}"][data-direction="${direction}"]`).addClass("text-primary")
        $(`th[data-field=${field}"]`).attr("data-direction", (direction === "DESC" ? "ASC" : "DESC"))
      }
    });
  }

  getSegmentURL(segment_id) {
    const url = new URL(window.location.href)
    url.search = `?segment_id=${segment_id}`
    return url.pathname + url.search
  }

  resetPage() {
    $(".segment").removeClass('active')
    $("#delete-segment, #update-segment-radio").hide();
    $("#delete-segment, #trigger-save-modal").off('click');
    $("#filter-summary").html("")
    this.renderLoadingBlock()
  }

  segmentOnClick(event) {
    this.toggleLoading(true);
    this.resetPage();

    this.segmentSelected(event.currentTarget);
  }

  addFilter(event) {
    event.preventDefault();
    event.stopPropagation();

    $(".filter-dropdown-menu").hide();
    $("#add-filter-menu").show();

    // 3. Prevent the "Click Outside" from firing when clicking inside the menu
    $('.filter-dropdown-menu').on('click', (event) => {
      event.stopPropagation();
    });

    // 4. Set up a one-time "Click Outside" listener
    // We use .one() so it automatically removes itself after firing once
    $(document).one('click', () => {
      $(".filter-dropdown-menu").hide();
    });
  }

  filterField(event) {
    const { searchField, filterType } = event.currentTarget.dataset;

    // 1. Hide all open menus
    $(".filter-dropdown-menu").hide();

    // 2. Set Stimulus state targets using .dataset (cleaner than setAttribute)
    this.search_fieldTarget.dataset.value = searchField;
    this.filter_typeTarget.dataset.value = filterType;

    // 3. Mapping for outliers (where ID doesn't perfectly match type)
    const specialCases = {
      "sms_subscribed": "#filter-sms-subscribed"
    };

    // 4. Resolve Target ID: Check map, then default pattern, then fallback
    const target = specialCases[filterType] || `#filter-${filterType}`;

    if ($(target).length) {
      $(target).show();
    } else {
      $('#filter-date').show(); // Fallback if no specific menu exists
    }

    // 5. Specific UI logic for duration-range
    if (filterType === "duration-range") {
      $(".apply-filter a").css('cursor', 'pointer');
    }
  }

  queryType(event) {
    const { renderUrl, cacheKey } = this.element.dataset;
    const type = this.filter_typeTarget.dataset.value;
    const field = this.search_fieldTarget.dataset.value;
    const queryType = $(event.currentTarget).val();

    // 1. Reset UI State
    $(".apply-filter a").css('cursor', 'not-allowed');
    $("#search_value").remove();

    // 2. Determine if we need an input field
    const manual = ["string", "integer", "date", "birthday", "engagement-integer"].includes(type);
    const simpleQuery = ["is unknown", "has any value"].includes(queryType);

    if (manual && !simpleQuery) {
      const inputType = type === "string" ? "text" : "number";

      // 3. Create input using a Template Literal for readability
      const input = `
      <input type="${inputType}" 
             id="search_value" 
             class="form-control" 
             data-controller="guest-database--filter-guests"
             data-action="keyup->guest-database--filter-guests#enterFilter" 
             data-filter-type="${type}" 
             data-search-field="${field}" 
             data-render-url="${renderUrl}" 
             data-cache-key="${cacheKey}">
    `;
      $(event.currentTarget).closest("label").append(input);
    }

    // 4. Update Apply Button cursor
    if ($(".dropdown-item [type=radio]:checked").length > 0) {
      $(".apply-filter a").css('cursor', 'pointer');
      //$(".apply-filter").click(applyFilter);
    }
  }

  enterFilter(event) {
    // Only proceed if 'Enter' (key code 13) is pressed
    if (event.which !== 13) return;

    event.stopImmediatePropagation();

    if (!this.validate_value()) return;

    // Extract metadata from the current input field
    const { filterType, searchField } = event.currentTarget.dataset;
    const searchValue = event.currentTarget.value; // The text typed by the user

    this.commitFilter(filterType, searchField, searchValue);
  }

  commitFilter(filterType, searchField, searchValue = null, mode = null) {
    const isContinuous = filterType === "continuously-sent";

    if (!isContinuous) {
      this.toggleLoading(true);
      this.renderLoadingBlock();
    }

    // 2. UI Cleanup
    $(".filter-dropdown-menu").hide();
    $("#trigger-save-modal").off('click');

    // 3. Resolve Query Type and Search Value
    // Mapping of filter types to their specific container IDs
    const filterMap = {
      'string': '#filter-string',
      'integer': '#filter-integer',
      'engagement-integer': '#filter-engagement-integer',
      'sms_subscribed': '#filter-sms-subscribed',
      'duration-range': '#filter-duration-range'
    };

    const container = filterMap[filterType] || `#filter-${filterType}`;
    const queryType = $(container).find("[type=radio]:checked").val();

    const manual = ["string", "integer", "engagement-integer", "date", "birthday"].includes(filterType);
    const simpleQuery = ["is unknown", "has any value"].includes(queryType);

    if (!searchValue) {
      if (manual && !simpleQuery) {
        searchValue = $("#search_value").val();
      }
      else {
        searchValue = queryType; // For locations, forms, gender, etc.
      }
    }

    // 4. Construct Params Object
    const filters = {
      filter_type: filterType,
      search_field: searchField,
      query_type: queryType,
      search_value: searchValue
    };

    if(mode)
      filters.mode = mode;

    if (filterType === "duration-range") {
      filters.start_date = new Date(this.start_date_value()).toISOString();
      filters.end_date = new Date(this.end_date_value()).toISOString();
    }

    // 5. Update State & UI
    const currentParams = this.params;
    currentParams.push(filters);
    this.params = currentParams;
    this.updateSequence();

    const { renderUrl, cacheKey } = this.element.dataset;

    // 6. Server Sync
    if (!isContinuous) {
      this.fetchData(renderUrl, {
        segment: "filter",
        cache_key: cacheKey,
        params_array: currentParams
      });
    }
    $("#search_value").remove();
  }

  valid_dropdown_selection(){
    return ($(".dropdown-item input[type='radio']:checked").length > 0) ||
        (this.start_date_value() && this.end_date_value())
  }

  validate_value(){
    return !document.getElementById("search_value") ||
        ($("#search_value").val().length > 0) ||
        (this.start_date_value() && this.end_date_value())
  }

  start_date_value(){
    return $("#start_date").val()
  }

  end_date_value(){
    return $("#end_date").val()
  }

  applyFilter() {
    if (!this.valid_dropdown_selection() || !this.validate_value()) return;

    const filterType = this.filter_typeTarget.dataset.value;
    const searchField = this.search_fieldTarget.dataset.value;
    const mode = event.currentTarget.dataset.filterMode;

    this.commitFilter(filterType, searchField, null, mode);
    //Enable below code to fix state to filters.
    //let stateObj = { id: params_array };
    //window.history.pushState(stateObj, params_array, "/app/" + $("body").attr("data-account-id") + "/guests?filters=" + JSON.stringify(params_array));
  };

  deleteButton(event) {
    event.stopPropagation()
    event.preventDefault()

    let confirmText = "Yes, delete this segment!";
    let warningText = "Removing cannot be undone";
    const messages = [ "Are you sure?", warningText, confirmText, "Cancel" ]

    this.withConfirmation(messages, () => {
      let segment_id = $("#delete-segment").attr("data-segment-id")
      $.ajax({
        type: "delete",
        url: `/app/${this.accountId}/guests/delete_segment`,
        data: { segment_id: segment_id },
      });

      $(`.segment[data-segment_id="${segment_id}"]`).remove();
      $(".segment").first().click();
    })
  }

  removeFilter(event){
    this.toggleLoading(true)
    this.renderLoadingBlock();
    $("#trigger-save-modal").off('click');

    let { arrayPosition, renderUrl, cacheKey } = event.currentTarget.dataset;
    let index = Number(arrayPosition);

    let filters = this.params;
    filters.splice(index, 1);
    this.params = filters;
    this.updateSequence();

    let data = { segment: "filter", params_array: filters, cache_key: cacheKey }

    this.fetchData(renderUrl, data)
    $("#filter-name").html($("#segment-name").text());
  }

  displayBulkActions(event) {
    if(!event.target.checked)
      $("#checkbox_all").prop('checked', false);
    $("#bulk_actions").toggle(this.getCheckedIds().length > 0);
  }

  checkAll(){
    const checked = $("#checkbox_all").is(":checked")
    $(".individual-checkbox input[type=checkbox]").prop("checked", checked);
    $("#bulk_actions").toggle(checked);
  }

  tagOnClick() {
    $(".tag-option").removeClass('selected-tag');
    event.currentTarget.classList.add('selected-tag')
    $("#submit_tags").attr('disabled', false);
  }

  removeTagOnClick() {
    $(".remove-tag-option").removeClass('selected-removal-tag');
    event.currentTarget.classList.add('selected-removal-tag')
    $("#submit_tag_removals").attr('disabled', false);
  }

  removeHuman(event) {
    event.stopPropagation();
    event.preventDefault();
    let controller = this;

    let counter = 0
    const counterElement = document.querySelector('.guest-table-header-count').innerText.replace(/,/g, '');
    if(Boolean(counterElement)) {
      counter = parseInt(counterElement)
    }

    let confirmText = "Yes, archive these guests!";
    let warningText = "Archiving will unsubscribe this guest from all communications and could impact your billing";
    const messages = [ "Are you sure?", warningText, confirmText, "Cancel" ]

    this.withConfirmation(messages, () => {
      if ($("#checkbox_all").is(":checked")) {
        controller.bulkAction("bulk_remove")
        counter = 0
      }
      else {
        controller.singleAction("remove")
        counter -= controller.getCheckedIds().length
        if(counter < 0)
          counter = 0
      }
      controller.updateGuestTable(counter)
      controller.showMessageWithTranslation("These guests will be removed in a few seconds.");
    })
  }

  revertHuman(event){
    event.stopPropagation()
    event.preventDefault()

    let counter = 0
    const counterElement = document.querySelector('.guest-table-header-count').innerText.replace(/,/g, '');
    if(Boolean(counterElement)) {
      counter = parseInt(counterElement)
    }

    let controller = this;
    let confirmText = "Yes, Unarchive these guests!";
    let warningText = "Unarchiving this guest will allow you to communicate with them again and could impact your billing";
    const messages = [ "Are you sure?", warningText, confirmText, "Cancel" ]

    this.withConfirmation(messages, () => {
      if ($("#checkbox_all").is(":checked")) {
        controller.bulkAction("bulk_revert")
        counter = 0;
      }
      else {
        controller.singleAction("revert")
        counter -= controller.getCheckedIds().length
        if(counter < 0)
          counter = 0
      }
      controller.updateGuestTable(counter);
      controller.showMessageWithTranslation("These guests will be reverted in a while.");
    })
  }

  updateGuestTable(counter = $('.guest-table-header-count').innerText) {
    setTimeout(() => {
      this.reloadSegmentMenu();
      $('.guest-table-header-count').innerText = counter
    },1000)
    $(".individual-checkbox [type=checkbox]:checked").closest('tr').remove();
  }

  reloadSegmentMenu() {
    const url = `/app/${this.accountId}/guests/`
    $.ajax({
      type: "GET",
      url: url + "render_segment_menu.js",
      data: { render_url: url + "render_guest_table.js", cache_key: Date.now(),
        segments_update: true, selected_segment_id: 'first_default' }
    })
  }

  blockHuman(event){
    event.stopPropagation()
    event.preventDefault()

    let controller = this;
    let confirmText = "Yes, block these guests!";
    let warningText = "Blocking will prevent this guest from connecting";
    const messages = [ "Are you sure?", warningText, confirmText, "Cancel" ]

    this.withConfirmation(messages, () => {
      if ($("#checkbox_all").is(":checked")) {
        controller.bulkAction("bulk_block");
      }
      else {
        controller.singleAction("block");
      }
      controller.updateGuestTable();
      controller.showMessageWithTranslation("These guests have been blocked.");
    })
  }

  unsubscribeHuman(event) {
    event.stopPropagation();
    event.preventDefault();

    let controller = this;
    let confirmText = "Yes, unsubscribe these guests!";
    let warningText = "This will unsubscribe this guest from receiving emails";

    const messages = [ "Are you sure?", warningText, confirmText, "Cancel" ]
    let message = 'Unsubscribed request received. Processing may take a few moments.';

    this.withConfirmation(messages, () => {
      if ($("#checkbox_all").is(":checked")) {
        controller.bulkAction("bulk_unsubscribe");
      }
      else {
        controller.singleAction("unsubscribe");
        message = 'These guests have been unsubscribed.';
      }
      controller.showMessageWithTranslation(messages);
    })
  }

  forgetDevise(event) {
    event.stopPropagation();
    event.preventDefault();

    let controller = this;
    let confirmText = "Yes, forget devices for these guests!";
    let warningText = "This will force all your selected guests to sign into your guest wifi again";

    const messages = [ "Are you sure?", warningText, confirmText, "Cancel" ]

    this.withConfirmation(messages, () => {
      const path = $("#checkbox_all").is(":checked") ? "bulk_forget_all_devices" : "forget_all_devices"
      controller.bulkAction(path, true);
      controller.showMessageWithTranslation('The devices for these guests have been forgotten.');
    })
  }

  bulkAction(path, includeGuestIds = false) {
    const data = {
      remote: true,
      filters: $("#checkbox_all").val()
    }
    if(includeGuestIds)
      data.guest_ids = this.getCheckedIds();

    $.ajax({
      type: "PATCH",
      url: `/app/${this.accountId}/guests/${path}`,
      data: data
    })
  }

  singleAction(path) {
    const data = {
      remote: true
    }

    this.getCheckedIds().forEach((human_id) => {
      $.ajax({
        type: "PATCH",
        url: `/app/${this.accountId}/guests/${path}/${human_id}`,
        data: data
      });
    })
  }

  withConfirmation(messages, callback) {
    let controller = this;
    Weglot.translate({
      'words': messages.map(message => ({ "t": 1, "w": message })),
      'languageTo': Weglot.getCurrentLang()
    }, (data) => {
      swal({
        title: data[0],
        text: data[1],
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: data[2],
        cancelButtonText: data[3],
        confirmButtonClass: 'btn btn-lg btn-danger waves-effect waves-light m-t-20',
        cancelButtonClass: 'btn btn-lg btn-transparent waves-effect waves-light m-l-10 m-t-20',
        buttonsStyling: false
      }).then(
          () => {
            controller.toggleLoading(true);
            callback();
            controller.toggleLoading(false);
          },
          (dismiss) => {
            if (dismiss === 'cancel') {
              // Handle cancel action if needed
            }
          })
    })
  }

  saveSegmentClick(){
    event.stopPropagation()
    $("#save-segment-modal").modal('toggle');
  }

  newToUpdate(){
    const update = $("#save-segment-modal [type=radio]:checked").val() === "update existing segment";
    $("#update-segment-button").toggle(update);
    $("#save-segment-button").toggle(!update);
  }

  updateSegment(){
    this.toggleLoading(true)

    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $("#save-segment-modal").modal('hide');

    let controller = this;
    let filters = this.params;
    let segment_id = $("#segment_id").attr("data-value");

    $(`[data-segment_id="${segment_id}"]`).attr('data-segment-filters', JSON.stringify(filters));

    // The count is not posted: data-humans-count is only populated once
    // render_guest_table replies, so saving before that stored a 0. The server
    // recounts and hands back the real number.
    $.ajax({
      type: "POST",
      url: `/app/${this.accountId}/guests/update_segment`,
      data: {id: segment_id, filters: filters},
      success: function(res) {
        $(`[data-segment_id="${segment_id}"]`).find('span:eq(1)').text(res[0]['count']);
        toastr.success('This segment has been updated.');
        controller.toggleLoading(false);
        //resetPage();
        //$("#delete-segment").click(deleteButton);
        //$('.segment[data-segment_id="' + segment_id + '"]').addClass('active');
      }
    });
  }

  validate_segment_name(event){
    let name = event.currentTarget.value.trim()
    $("#save-segment-button").attr("disabled", name.length < 1)
  }

  createSegment(){
    this.toggleLoading(true)
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('.segment').removeClass('active');
    $("#save-segment-modal").modal('hide');

    const controller = this;
    let filters = this.params;
    let name = $("#segment-name-input").val()

    $.ajax({
      type: "POST",
      url: `/app/${this.accountId}/guests/save_segment`,
      data: { name: name, filters: filters },
      success: function(res) {
        let html = `<div class='segment' style='text-align: left !important;' data-controller='guest-database--filter-guests' data-segment='custom' data-segment_id=${res[0]['id']} data-action='click->guest-database--filter-guests#segmentOnClick' data-segment-filters='${JSON.stringify(filters)}' data-segment-name='${name}' data-segment-selected='true' data-render-url='guests/render_guest_table.js'>
                              <h4 class='header-title'>
                                <span>${name}</span>
                                <span class='pull-right muted-text'>${res[0]['count']}</span>
                              </h4>
                            </div>`
        $("#segment-menu").append(html);
        controller.toggleLoading(false)
      }
    });
  }

  submitTagRemoval() {
    const controller = this;
    const selection = $(".selected-removal-tag")
    const path = $("#checkbox_all").is(":checked") ? "bulk_remove_tag_users" : "remove_tag_users"

    const data = {
      new_tag: false,
      tag_id: selection.data("tag-id"),
      guest_ids: this.getCheckedIds(),
      filters: $("#checkbox_all").val()
    }

    $.ajax({
      type: "POST",
      url: `/app/${this.accountId}/guests/${path}`,
      data: data,
      success: () => {
        $("#remove-tags-modal").modal('hide');
        toastr.success('The tag has been removed from these guests.');
        $("#submit_tag_removals").attr('disabled', true);
        $("#tag_search_field").val('');
        controller.searchTags();
        controller.toggleLoading(false)
      }
    })
  }

  getCheckedIds() {
    return Array.from($(".individual-checkbox input[type=checkbox]:checked")).map(checkbox => checkbox.value)
  }

  submitTag() {
    this.toggleLoading(true);
    const controller = this;
    const selection = $(".selected-tag")
    const newTag = selection.hasClass("new-tag")
    const path = $("#checkbox_all").is(":checked") ? "bulk_tag_users" : "tag_users"

    const data = {
      new_tag: newTag,
      tag_name: newTag ? $("#tag_search_field").val() : null,
      tag_id: newTag ? null : selection.data("tag-id"),
      guest_ids: this.getCheckedIds(),
      filters: $("#checkbox_all").val()
    }

    $.ajax({
      type: "POST",
      url: `/app/${this.accountId}/guests/${path}`,
      data: data,
      success: () => {
        $("#add-tags-modal").modal('hide')
        toastr.success('Guests have been tagged successfully.');
        $("#tag_search_field").val('');
        controller.searchTags()
        controller.toggleLoading(false)
      }
    })
  }

  searchRemoveTags(){
    const query = $("#remove_tag_search_field").val().toLowerCase();
    let matches = this.getMatchingTags(query);

    let html = matches.map(tag =>`
      <div class='remove-tag-option' data-tag-id='${tag[0]}' data-controller='guest-database--filter-guests' 
           data-action='click->guest-database--filter-guests#removeTagOnClick'>
        ${tag[1]}
      </div>
    `).join('');

    if (matches.length === 0 && query.length > 0) {
      html = `<div class='no-result text-center'>Could not find tag: ${query}</div>`
    }

    $("#remove_tag_summary").html(html);
    feather.replace();

    $("#submit_tags").attr('disabled', $(".selected-removal-tag").length < 1);
  }

  searchTags() {
    const query = $("#tag_search_field").val().toLowerCase();
    const matches = this.getMatchingTags(query);

    let html = matches.map(tag =>`
      <div class='tag-option' data-tag-id='${tag[0]}' data-controller='guest-database--filter-guests' 
           data-action='click->guest-database--filter-guests#tagOnClick'>
        ${tag[1]}
      </div>
    `).join('');

    // If no matches found and user typed something, offer to create a new tag
    if (matches.length === 0 && query.length > 0) {
      html = `
        <div class='tag-option new-tag' data-action='click->guest-database--filter-guests#tagOnClick'>
          <i data-feather='tag'></i> Create new tag: '${query}'
        </div>`;
    }
    $("#tag_summary").html(html);
    feather.replace();

    $("#submit_tags").attr('disabled', $(".selected-tag").length < 1);
  }

  getMatchingTags (query) {
    const tags = JSON.parse(this.element.dataset.tagList || "[]");
    return tags.filter(tag => tag[1].toLowerCase().includes(query));
  }

  setTrigger(){
    const sequence = $("#sequence").attr("data-sequence");
    const interaction_id = $("#interaction_id").attr("data-params");

    $.ajax({
      type: "POST",
      url: `/app/${this.accountId}/interaction/update_trigger`,
      data: { id: interaction_id, filters: this.params, sequence: sequence },
    });
  }

  toggleColumn(event) {
    const { column } = event.target.dataset;
    const isVisible = event.target.checked;

    // Use a Set to handle unique values automatically
    const hiddenSet = new Set(JSON.parse(localStorage.getItem("hiddenGuestColumns") || "[]"));

    if (isVisible) {
      hiddenSet.delete(column);
    } else {
      hiddenSet.add(column);
    }

    localStorage.setItem("hiddenGuestColumns", JSON.stringify([...hiddenSet]));
    this.updateColumnVisibility();
  }

  updateColumnVisibility() {
    const hidden = JSON.parse(localStorage.getItem("hiddenGuestColumns") || "[]")
    const columns = ["name", "email", "phone", "visits", "last-visit", "optin"]
    columns.forEach(column => {
      const isHidden = hidden.includes(column)
      document.querySelectorAll(`.col-${column}`).forEach(el => {
        el.style.display = isHidden ? "none" : "";
      })
      const checkbox = document.querySelector(`input[data-column="${column}"]`)
      if (checkbox) checkbox.checked = !isHidden;
    })
  }

  renderLoadingBlock() {
    $("#render_block").html('<div class="spinner-border text-center text-primary m-t-100 m-b-100" role="status"><span class="sr-only">Loading...</span></div>')
  }

  updateFilterSummary(filters) {
    filters = JSON.stringify(filters);
    const { cacheKey, renderUrl } = this.element.dataset;
    $("#filter-summary").attr("data-filters", filters)
        .html(`
              <div data-controller='general--render-filters' 
                   data-render-url='${renderUrl}' 
                   data-filters='${filters}' 
                   data-target='general--render-filters.filters'
                   data-cache-key='${cacheKey}'>
              </div>
        `);
  }

  setSegmentName() {
    $(".segment-name").html(this.element.dataset.segmentName)
  }

  setFilterName() {
    $("#filter-name").html(this.element.dataset.segmentName)
  }
}
